console.log("✅ custom.js 読み込まれました！");

//===========================
// メイン画像を2枚目に差し替える
//===========================
function setSecondImageAsMain() {
  const allSlides = document.querySelectorAll('.product__media-item');
  if (allSlides.length < 2) return;

  const currentActive = document.querySelector('.product__media-item.is-active');
  const secondSlide = allSlides[1]; // 2枚目

  if (currentActive && secondSlide) {
    currentActive.classList.remove('is-active');
    secondSlide.classList.add('is-active');
    console.log("✅ メイン画像を2枚目に設定しました");
  }
}

//===========================
// サムネイル1枚目非表示
//===========================
function hideFirstThumbnail() {
  const firstThumbnail = document.querySelector('.thumbnail-list__item');
  if (firstThumbnail) {
    firstThumbnail.style.display = 'none';
    console.log("🚫 サムネイル1枚目を非表示にしました（バリエーションあり）");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  // 👉 バリエーションがある商品だけ処理する
  const variantSelector = document.querySelector('variant-radios, variant-selects');
  if (!variantSelector) {
    console.log("ℹ️ バリエーションなし商品のため処理スキップ");
    return;
  }

  // 初期処理
  hideFirstThumbnail();
  setSecondImageAsMain();

  // サムネイルリストの変化を監視
  const observerTarget = document.querySelector('.thumbnail-list');
  if (observerTarget) {
    const observer = new MutationObserver(() => {
      hideFirstThumbnail();
    });

    observer.observe(observerTarget, { childList: true, subtree: true });
    console.log("👀 サムネイル監視中...");
  }

  // バリエーション切替イベント時
  document.addEventListener("variant:change", () => {
    hideFirstThumbnail();
  });
});
